import { Controller } from '@hotwired/stimulus';

import { apply } from '@/modules/mask';

export default class extends Controller {
  connect() {
    apply(this.element, { mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }] });
  }
}
